import { Fade, IconButton, Typography } from '@material-ui/core'
import RefreshIcon from '@material-ui/icons/Refresh'
import React from 'react'

import NoDataImage from '../../assets/images/No-Data.png'
import { SlaPolicy } from '../../helpers/slaPolicies'
import { getTranslate } from '../../localization'
import SlaPolicyRow from './SlaPolicyRow'
import SlaPolicyRowSkeleton from './SlaPolicyRow.skeleton'
import useStyles from './styles/SlaPoliciesTable.styles'

interface SlaPoliciesTableProps {
  policies: SlaPolicy[]
  loading: boolean
  settled: boolean
  retiring: boolean
  onEdit: (policy: SlaPolicy) => void
  onRetire: (policy: SlaPolicy) => void
  reloadData: () => void
}

export default function SlaPoliciesTable({
  policies,
  loading,
  settled,
  retiring,
  onEdit,
  onRetire,
  reloadData
}: SlaPoliciesTableProps) {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <div className={classes.tableHead}>
        <div>
          <Typography variant="body1">{getTranslate('Policy')}</Typography>
        </div>
        <div>
          <Typography variant="body1">{getTranslate('Applies to')}</Typography>
        </div>
        <div>
          <Typography variant="body1">{getTranslate('Respond by')}</Typography>
        </div>
        <div>
          <Typography variant="body1">{getTranslate('Resolve by')}</Typography>
        </div>
        <div>
          <Typography variant="body1">{getTranslate('Created')}</Typography>
        </div>
        <div className={classes.actionsCell}>
          <IconButton onClick={reloadData} aria-label={getTranslate('Refresh')}>
            <RefreshIcon fontSize="small" />
          </IconButton>
        </div>
      </div>

      {loading && !policies.length
        ? Array(5)
            .fill('')
            .map((item, index) => (
              <SlaPolicyRowSkeleton
                key={`sla-policy-skeleton${item}${index.toString()}`}
              />
            ))
        : null}

      {policies.map((policy) => (
        <Fade in timeout={600} key={`${policy.policyId}-${policy.version}`}>
          <div data-cy="tableRowSlaPolicyData">
            <SlaPolicyRow
              policy={policy}
              retiring={retiring}
              onEdit={onEdit}
              onRetire={onRetire}
            />
          </div>
        </Fade>
      ))}

      {settled && !policies.length && (
        <div className={classes.noDataImageContainer}>
          <img src={NoDataImage} alt={getTranslate('No policies yet.')} />
        </div>
      )}
    </div>
  )
}
